export const userRolesMap = {
  slideLibrary: 'SL-User',
  slideLibraryAdmin: 'SL-Admin',
};
